import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { getOwner } from '@ember/application';
import { dropTask, restartableTask } from 'ember-concurrency';
import { beebeeAjaxPost } from '../lib/utility/ajax.js';
import { typeOf } from '@ember/utils';
import 'moment-timezone';
import { stateChangeWillLoseData, smartUpdateCustomFieldsForState } from '../lib/utility/models.js';
import '../lib/utility/province.js';
import { notifyUserError } from '../lib/utility/misc.js';
import getConfig from '../lib/get-config.js';
import { guidFor } from '@ember/object/internals';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<button\n  type=\'button\'\n  class=\'status-pill {{if this.changeStatusTask.isRunning \"loading\"}}\'\n  disabled={{this.changeStatusTask.isRunning}}\n  data-toggle=\'zf-status-{{this.uid}}\' ...attributes\n>\n  <span class=\'status-dot\' style=\'background: {{this.itemStatus.status_color}}\'></span>\n  {{this.itemStatus.status_name}}\n  <FaIcon @icon=\'chevron-down\' />\n</button>\n\n<BbDropdown\n  @onZfUiReady={{fn (mut this.zfStatus)}}\n  @id=\'zf-status-{{this.uid}}\'\n  @notClose={{this.inConfirmStep}} data-test-set-zf-status\n>\n  {{#if this.confirmStateChange}}\n    <div class=\'box-message warning\'>\n      <div class=\'icon\'>\n        <FaIcon @icon=\'circle-exclamation\' />\n      </div>\n      <div class=\'message\'>\n        <div class=\'description\'>\n          <p>\n            {{t \'state change will delete custom fields\'}}\n          </p>\n        </div>\n        <div class=\'button-group expanded\'>\n          <button\n            type=\'button\'\n            class=\'button\' data-test-set-confirm-state-change {{on \'click\' (fn (mut this.confirmStateChange) false)}}\n          >\n            {{t \'cancel\'}}\n          </button>\n          <button\n            type=\'button\'\n            class=\'button primary {{if this.changeStatusTask.isRunning \"loading\"}}\'\n            disabled={{this.changeStatusTask.isRunning}}\n            data-test-confirm-change\n            {{on \'click\' this.confirmChange}}\n          >\n            {{t \'confirm\'}}\n          </button>\n        </div>\n      </div>\n    </div>\n  {{else if (and this.confirmDisdetto this.isNuova)}}\n    <div class=\'nv-sp-cancel\' data-test-nv-cancel-step>\n      <p class=\'nv-sp-cancel-t\'>{{t \'nv.event.cancel.title\'}}</p>\n      <BbCheckbox @label={{t \'nv.event.cancel.drop_price\'}} @content={{this.resetPrice}} @setContent={{fn (mut this.resetPrice)}} />\n      {{#if this.alreadyPaidLabel}}\n        <p class=\'nv-sp-cancel-note\' data-test-nv-cancel-paid>{{t \'nv.event.cancel.paid_note\' amount=this.alreadyPaidLabel}}</p>\n      {{/if}}\n      <BbCheckbox\n        @label={{if @applicationController.isClinic (t \'add patient to waiting list\') (t \'nv.event.cancel.add_waiting_list\')}}\n        @content={{this.insertWaitingList}}\n        @setContent={{fn (mut this.insertWaitingList)}}\n        @disabled={{this.canAddWaitingList}}\n      />\n      <div class=\'nv-sp-cancel-act\'>\n        <button type=\'button\' class=\'nv-btn\' data-test-set-confirm-disdetto {{on \'click\' this.keepAppointment}}>\n          <span class=\'nv-cap\'>{{t \'nv.event.cancel.keep\'}}</span>\n        </button>\n        <button\n          type=\'button\'\n          class=\'nv-btn nv-btn--danger\'\n          aria-busy={{if this.changeStatusTask.isRunning \'true\' \'false\'}}\n          disabled={{this.changeStatusTask.isRunning}}\n          data-test-confirm-change-2\n          {{on \'click\' this.confirmChange}}\n        >\n          <span class=\'nv-cap\'>{{t \'nv.event.cancel.confirm\'}}</span>\n        </button>\n      </div>\n    </div>\n  {{else if this.confirmDisdetto}}\n    <div class=\'box-message warning\'>\n      <div class=\'icon\'>\n        <FaIcon @icon=\'circle-exclamation\' />\n      </div>\n      <div class=\'message\'>\n        <div class=\'headline\'>\n          {{t \'you are about to cancel the appointment\'}}\n        </div>\n        <div class=\'description\'>\n          <p>\n            <BbCheckbox\n              @label=\'{{t \"Cancel appointment price\"}}\'\n              @content={{this.resetPrice}}\n              @setContent={{fn (mut this.resetPrice)}}\n            />\n            <BbCheckbox\n              @label={{if @applicationController.isClinic (t \'add patient to waiting list\') (t \'nv.event.cancel.add_waiting_list\')}}\n              @content={{this.insertWaitingList}}\n              @setContent={{fn (mut this.insertWaitingList)}}\n              @disabled={{this.canAddWaitingList}}\n            />\n          </p>\n        </div>\n        <div class=\'button-group expanded\'>\n          <button type=\'button\' class=\'button\' data-test-set-confirm-disdetto {{on \'click\' (fn (mut this.confirmDisdetto) false)}}>\n            {{t \'cancel\'}}\n          </button>\n          <button\n            type=\'button\'\n            class=\'button primary {{if this.changeStatusTask.isRunning \"loading\"}}\'\n            disabled={{this.changeStatusTask.isRunning}}\n            data-test-confirm-change-2\n            {{on \'click\' this.confirmChange}}\n          >\n            {{t \'confirm\'}}\n          </button>\n        </div>\n      </div>\n    </div>\n  {{else}}\n    <ul class=\'status-list\'>\n      {{#each this.statusList as |status|}}\n        <li\n          class=\'status-list-item {{if this.changeStatusTask.isRunning \"loading\"}} {{if (is-equal status.id this.itemStatus.id) \"is-current\"}}\'\n          role=\'button\'\n          aria-current={{if (is-equal status.id this.itemStatus.id) \'true\'}}\n          data-test-select-status\n          {{on \'click\' (fn this.selectStatus status)}}\n        >\n          <span class=\'sm-dot\' style=\'background: {{status.status_color}}\'></span>\n          {{status.status_name}}\n        </li>\n      {{/each}}\n    </ul>\n  {{/if}}\n</BbDropdown>");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0;
let BbStatusPickerComponent = (_class = class BbStatusPickerComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "notify", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    // Stable per-instance ID for the ZfDropdown target (replaces Classic elementId).
    this.uid = guidFor(this);
    // Captured from <BbDropdown @onZfUiReady={{fn (mut this.zfStatus)}} …>
    _initializerDefineProperty(this, "zfStatus", _descriptor5, this);
    // Local UI state (was initialised in didInsertElement)
    _initializerDefineProperty(this, "confirmDisdetto", _descriptor6, this);
    _initializerDefineProperty(this, "confirmStateChange", _descriptor7, this);
    _initializerDefineProperty(this, "resetPrice", _descriptor8, this);
    _initializerDefineProperty(this, "insertWaitingList", _descriptor9, this);
    _initializerDefineProperty(this, "tmpStatus", _descriptor0, this);
  }
  // -----------------------------------------------------------------------
  // Getters (replaced computed())
  // -----------------------------------------------------------------------

  // service:ui is optional (an app without it renders the classic UI); its isNuova is tracked
  get isNuova() {
    return Boolean(getOwner(this)?.lookup('service:ui')?.isNuova);
  }

  /**
   * «UI nuova» cancel step: what the patient already paid for this appointment (price − still due), formatted, or
   * null. «Togli il prezzo» does not touch the payments: the note says so before the user confirms.
   */
  get alreadyPaidLabel() {
    const item = this.args.item;
    if (!item) return null;
    const price = Number(item.price);
    const due = item.total_due == null ? null : Number(item.total_due);
    if (!(price > 0) || due == null || Number.isNaN(due)) return null;
    const paid = Math.round((price - due) * 100) / 100;
    if (!(paid > 0)) return null;
    return this.intl.formatNumber(paid, {
      style: 'currency',
      currency: 'EUR'
    });
  }
  get modelType() {
    return this.args.item?.get('constructor.modelName') ?? null;
  }
  get canAddWaitingList() {
    return !this.args.patientId;
  }

  // While a confirm step is showing (disdetto checkboxes or data-loss warning),
  // the dropdown pane must stay open: mark it not-close so the global
  // outside-click / _closeAllDropdowns handler skips it and the user can
  // actually read the options and click confirm.
  get inConfirmStep() {
    return this.confirmDisdetto || this.confirmStateChange;
  }
  get itemStatusName() {
    if (!this.modelType) {
      return false;
    }
    return `${this.modelType}_state`;
  }
  get itemStatus() {
    if (!this.modelType) {
      return false;
    }
    return this.args.item?.get?.(`${this.modelType}_state`) ?? this.args.item?.[`${this.modelType}_state`];
  }
  get statusList() {
    if (!this.modelType) {
      return false;
    }
    return this.args.status || this.session.me?.organization?.[`${this.modelType}_states`];
  }

  // -----------------------------------------------------------------------
  // Tasks
  // -----------------------------------------------------------------------

  *saveRecordTask() {
    // notifyUser=false: saveRecordRelated already shows a notification on error;
    // we manage it here so we can close the dropdown first.
    const sItem = yield this.args.applicationController.saveRecordRelated(this.args.item, false);

    // `item` is a live arg owned by the parent list/detail; the save above can
    // null it (reload / teardown). Guard before the post-save deref.
    if (this.isDestroying || this.isDestroyed || !this.args.item) return;
    if (!sItem || !sItem[0]?.data?.id) {
      // AUDIT NOTE: saveRecordRelated already rolls back + notifies on error.
      return;
    }
    const storeItem = this.store.peekRecord(this.args.item.constructor.modelName, sItem[0].data.id);
    this.args.item.set?.('id', storeItem?.id); // keep reference if caller holds it

    this.notify.success(this.intl.t('save done'));
    const dropdownEl = document.getElementById(`zf-status-${this.uid}`);
    if (dropdownEl?.classList.contains('is-open')) {
      dropdownEl.classList.remove('is-open');
      if (!document.querySelector('.data-dropdown.is-open')) {
        document.body.classList.remove('dropdown-open');
      }
    }
    if (typeOf(this.args.actionChange) === 'function') {
      this.args.actionChange(this.tmpStatus);
    }
  }

  /**
   * Adds the patient to the waiting list. Returns `false` ONLY when the API refused the
   * insert, so `changeStatusTask` can keep the status change from running behind a failed
   * waiting-list entry (its previous behaviour, when the rejection aborted it). "Nothing to
   * do" is a success: without a patientId there is no entry to create.
   */
  *addPatientWaitingListTask() {
    if (!this.args.patientId) {
      return true;
    }
    const newContact = {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
      notes: null,
      contact_id: this.args.patientId,
      product_id: this.args.treatmentId,
      specialist_id: this.args.specialistaId
    };

    // POST /api/v1/waitinglist (api_beebeeboard src/hono/routes/contact.routes.ts:132,
    // handler src/controllers/waitinglist.ts:41 `insert_waitinglist`) carries
    // `requireActiveSubscription()` but NO `requirePermission(...)`, so it cannot answer a
    // permission 403 on the user's role — it answers 403 only for a blocked subscription
    // ("Account bloccato. Contatta l'amministratore", permissions.ts:126) and 400 with the
    // real reason when the SP throws (waitinglist.ts:59). beebeeAjaxPost REJECTS on all of
    // those: unguarded, the rejection aborted the task here and escaped as an uncaught
    // task-instance rejection to Sentry, while the user saw the dropdown simply close with
    // neither an error nor the patient on the waiting list — a silent no-op.
    try {
      yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/waitinglist`, this.session.token, newContact);
    } catch (e) {
      notifyUserError(this.notify, e, this.intl);
      return false;
    }
    return true;
  }
  *changeStatusTask(status, force = false) {
    // Capture the item the user acted on: `custom_fields` below is an async
    // relationship, and a parent list/detail can swap or null `@item` during
    // that await (live args proxy). Operate on the captured record for the
    // whole mutation, and bail if it is already gone — a null item means there
    // is nothing to change (avoids a crash on the core status write).
    const item = this.args.item;
    if (!item) return false;
    // Capture the model type from the captured record too: `this.modelType` is a
    // getter over the LIVE `this.args.item`, so a host swap/null during the await
    // below would make the state lookup and `_state` write (further down) read a
    // stale/absent type — silently dropping the status change or writing the wrong
    // key. Pin it here alongside `item`.
    const modelType = item.get('constructor.modelName');
    const stateModelName = modelType ? `${modelType}_state` : false;
    const customFields = yield item.custom_fields;

    // Step 1: disdetto confirmation (only for disdetto state with askDisdetto=true)
    if (!force && this.args.askDisdetto && status.id === '1001') {
      this.tmpStatus = status;
      this.confirmDisdetto = true;
      return false;
    }

    // Step 2: custom_field data loss confirmation (only if not forced and data would be lost)
    if (!force && stateChangeWillLoseData(item, status.id, customFields)) {
      this.tmpStatus = status;
      this.confirmStateChange = true;
      return false;
    }
    if (this.confirmDisdetto && this.resetPrice) {
      item.price = null;
    }
    if (this.confirmDisdetto && this.insertWaitingList) {
      // The unguarded POST used to abort THIS task too when it rejected, so a refused
      // waiting-list insert also left the status unchanged. Keep that: the operator asked
      // for both halves of one action, and half of it now reports why it failed.
      const listed = yield this.addPatientWaitingListTask.perform();
      if (listed === false) {
        return false;
      }
    }
    this.confirmDisdetto = false;
    this.confirmStateChange = false;
    const newState = this.store.peekRecord(`${stateModelName}`, status.id);
    if (!newState) {
      this.notify.error(this.intl.t('beebeeboard error'));
      return;
    }
    item[`${stateModelName}`] = newState;
    item.my_dirty = !item.get('my_dirty');
    smartUpdateCustomFieldsForState(this.session.me, item, newState, this.store, customFields);
    if (item.get('id')) {
      yield this.saveRecordTask.perform();
    } else {
      if (typeOf(this.args.actionChange) === 'function') {
        this.args.actionChange(status);
      }
    }
  }

  // -----------------------------------------------------------------------
  // Actions (confirm button wrappers — avoid Event-leak from {{on}} + fn)
  // -----------------------------------------------------------------------

  /** «UI nuova» «Non disdire»: the user is done — forget the choices and close, not back to the state list. */
  keepAppointment() {
    this.confirmDisdetto = false;
    this.resetPrice = false;
    this.insertWaitingList = false;
    this.zfStatus?.close?.();
  }
  confirmChange() {
    this.changeStatusTask.perform(this.tmpStatus, true);
  }
  selectStatus(status) {
    this.changeStatusTask.perform(status);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "notify", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "zfStatus", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "confirmDisdetto", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "confirmStateChange", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "resetPrice", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "insertWaitingList", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "tmpStatus", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "saveRecordTask", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "saveRecordTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addPatientWaitingListTask", [restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "addPatientWaitingListTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeStatusTask", [restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "changeStatusTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keepAppointment", [action], Object.getOwnPropertyDescriptor(_class.prototype, "keepAppointment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirmChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "confirmChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectStatus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectStatus"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbStatusPickerComponent);

export { BbStatusPickerComponent as default };
//# sourceMappingURL=bb-status-picker.js.map
